var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.82929 2H18.75C19.4404 2 20 2.55964 20 3.25C20 3.94036 19.4404 4.5 18.75 4.5H8.59865C8.07994 5.3967 7.11042 6 6 6C4.88958 6 3.92006 5.3967 3.40135 4.5H1.25C0.559644 4.5 0 3.94036 0 3.25C0 2.55964 0.559644 2 1.25 2H3.17071C3.58254 0.834808 4.69378 0 6 0C7.30622 0 8.41746 0.834808 8.82929 2ZM0 10.25C0 9.55964 0.559644 9 1.25 9H11.1707C11.5825 7.83481 12.6938 7 14 7C15.3062 7 16.4175 7.83481 16.8293 9H18.75C19.4404 9 20 9.55964 20 10.25C20 10.9404 19.4404 11.5 18.75 11.5H16.5987C16.0799 12.3967 15.1104 13 14 13C12.8896 13 11.9201 12.3967 11.4013 11.5H1.25C0.559644 11.5 0 10.9404 0 10.25ZM1.25 16C0.559644 16 0 16.5596 0 17.25C0 17.9404 0.559644 18.5 1.25 18.5H6.40135C6.92006 19.3967 7.88958 20 9 20C10.1104 20 11.0799 19.3967 11.5987 18.5H18.75C19.4404 18.5 20 17.9404 20 17.25C20 16.5596 19.4404 16 18.75 16H11.8293C11.4175 14.8348 10.3062 14 9 14C7.69378 14 6.58254 14.8348 6.17071 16H1.25Z",
    fill: "#575757"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/icon_filter.5b183bd82c290296f4fefb23ef0dc861.svg";
export { ForwardRef as ReactComponent };